import { createFileRoute, Navigate } from '@tanstack/react-router';

import { useWorkspace } from '@/app/context';
import { filterNav, PROJECT_NAV } from '@/app/navigation';

export const Route = createFileRoute('/_app/projects/$projectId/resources/')({
  component: AreaIndex,
});

/** The first resources tab this person may see (a subcontractor lands on its requests). */
function AreaIndex() {
  const { projectId } = Route.useParams();
  const { nav } = useWorkspace();
  const first = filterNav(PROJECT_NAV, nav).find((item) => item.id === 'project.resources')
    ?.children?.[0];
  return (
    <Navigate to={first?.to ?? '/projects/$projectId/overview'} params={{ projectId }} replace />
  );
}
